import React, { useContext, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import Repo from "../../Utility/Repo";
import { TokenContext } from "../../Components/TokenContext";

const ListISEEValidationLogs = () => {
  const apiToken = useContext(TokenContext);

  const history = useHistory();

  const [jobs, setJobs] = useState([]);

  const [filteredJobs, setFilteredJobs] = useState([]);

  const [loading, setLoading] = useState(true);

  const [filters, setFilters] = useState({
    stato: "",
    data: "",
  });

  const STATUS = {
    CREATED: 0,
    RUNNING: 1,
    SUCCESS: 2,
    ERROR: 3,
  };

  useEffect(() => {
    loadJobs();
  }, []);

  useEffect(() => {
    applyFilters();
  }, [filters, jobs]);

  const loadJobs = async () => {
    try {
      setLoading(true);

      const response =
        await Repo.getAggiornamentiJobsIsee(
          apiToken
        );

      setJobs(response.data || []);
      setFilteredJobs(response.data || []);
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  const applyFilters = () => {
    let result = [...jobs];

    if (filters.stato !== "") {
      result = result.filter(
        (x) => x.stato === Number(filters.stato)
      );
    }

    if (filters.data) {
      result = result.filter(
        (x) => x.dataInsert === filters.data
      );
    }

    setFilteredJobs(result);
  };

  const getBadge = (status) => {
    switch (status) {
      case STATUS.CREATED:
        return (
          <span className="badge badge-secondary">
            Creato
          </span>
        );

      case STATUS.RUNNING:
        return (
          <span className="badge badge-warning">
            In esecuzione
          </span>
        );

      case STATUS.SUCCESS:
        return (
          <span className="badge badge-success">
            Completato
          </span>
        );

      case STATUS.ERROR:
        return (
          <span className="badge badge-danger">
            Errore
          </span>
        );

      default:
        return (
          <span className="badge badge-light">
            Sconosciuto
          </span>
        );
    }
  };

  const getProgress = (job) => {
    if (!job.totale || job.totale === 0) {
      return 0;
    }

    return Math.round(
      ((job.completati + job.errori) * 100) /
        job.totale
    );
  };

  if (loading) {
    return (
      <div className="container mt-4">
        Caricamento jobs...
      </div>
    );
  }

  return (
    <div className="container mt-4">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <div>
          <h4>Storico validazioni ISEE</h4>

          <small className="text-muted">
            Storico dei batch di validazione automatica ISEE
          </small>
        </div>


      </div>

      <div className="row mb-3">
        <div className="col-md-6">
          <input
            type="date"
            className="form-control"
            value={filters.data}
            onChange={(e) =>
              setFilters({
                ...filters,
                data: e.target.value,
              })
            }
          />
        </div>

        <div className="col-md-6">
          <select
            className="form-control"
            value={filters.stato}
            onChange={(e) =>
              setFilters({
                ...filters,
                stato: e.target.value,
              })
            }
          >
            <option value="">
              Tutti gli stati
            </option>

            <option value="0">
              Creato
            </option>

            <option value="1">
              In esecuzione
            </option>

            <option value="2">
              Completato
            </option>

            <option value="3">
              Errore
            </option>
          </select>
        </div>
      </div>

      <div className="table-responsive">
        <table className="table table-hover table-bordered">
          <thead>
            <tr>
              <th>Data</th>

              <th>Stato</th>

              <th>Totale</th>

              <th>Completati</th>

              <th>Errori</th>

              <th>Avanzamento</th>

              <th>Azioni</th>
            </tr>
          </thead>

          <tbody>
            {filteredJobs.length === 0 && (
              <tr>
                <td
                  colSpan="7"
                  className="text-center"
                >
                  Nessun job trovato
                </td>
              </tr>
            )}

            {filteredJobs.map((job) => {
              const progress =
                getProgress(job);

              const isStuck =
                job.stato === STATUS.RUNNING &&
                (job.completati +
                  job.errori) <
                  job.totale;

              return (
                <tr
                  key={job.jobId}
                  className={
                    isStuck
                      ? "table-warning"
                      : ""
                  }
                >
                  <td>{job.dataInsert}</td>

                  <td>
                    {getBadge(job.stato)}
                  </td>

                  <td>
                    <b>{job.totale}</b>
                  </td>

                  <td className="text-success fw-bold">
                    {job.completati || 0}
                  </td>

                  <td className="text-danger fw-bold">
                    {job.errori || 0}
                  </td>

                  <td>
                    <div
                      className="progress"
                      style={{
                        height: "22px",
                      }}
                    >
                      <div
                        className={`progress-bar ${
                          progress === 100
                            ? "bg-success"
                            : "bg-warning"
                        }`}
                        role="progressbar"
                        style={{
                          width: `${progress}%`,
                        }}
                      >
                        {progress}%
                      </div>
                    </div>
                  </td>

                  <td>
                    <button
                      className="btn btn-outline-primary btn-sm"
                      onClick={() =>
                        history.push(
                          `/gestione_aggiornamenti/${job.jobId}/logs`
                        )
                      }
                    >
                      Dettaglio
                    </button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ListISEEValidationLogs;